import { render } from "./IncludedItemsStep.vue?vue&type=template&id=f70c7ebe&scoped=true"
import script from "./IncludedItemsStep.vue?vue&type=script&lang=js"
export * from "./IncludedItemsStep.vue?vue&type=script&lang=js"

import "./IncludedItemsStep.vue?vue&type=style&index=0&id=f70c7ebe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70c7ebe"]])

export default __exports__